import * as api from '../../api/index.js';
import React, { useState } from 'react';
import { Table, Button, FormControl, InputGroup, Container, Row, Col, Badge, Modal } from 'react-bootstrap';
import { deleteFeedback } from '../../api/index.js';
import useAxiosData from '../../hooks/useAxiosData.js';

const FeedbackControlPanel = () => {
    const [feedbacks, , setFeedbacks] = useAxiosData(api.fetchFeedbacks, []);
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [feedbackToDelete, setFeedbackToDelete] = useState(null);

    const handleDeleteButton = (feedback) => {
        setFeedbackToDelete(feedback);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!feedbackToDelete) return;
        
        await deleteFeedback(feedbackToDelete._id);
        setFeedbacks(feedbacks.filter(feedback => feedback._id !== feedbackToDelete._id));
        setShowDeleteModal(false);
        setFeedbackToDelete(null);
    };

    const filteredFeedbacks = feedbacks.filter(feedback =>
        feedback.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        feedback.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        feedback.feedback.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    
                    <h1 id="role-manager-title" className="text-center mb-4">Feedback Manager</h1>

                    <div className="card p-3 p-md-4 shadow-sm">
                        <InputGroup className="mb-3">
                            
                            <label htmlFor="feedbackSearch" className="visually-hidden">
                                Search feedback
                            </label>
                            <FormControl
                                id="feedbackSearch"
                                placeholder="Search feedback"
                                aria-label="Search feedback"
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="input-field"
                            />
                        </InputGroup>

                        {/* Desktop/Tablet: Table view */}
                        <div className="table-responsive d-none d-md-block">
                            <Table striped bordered hover responsive className="table-sm table-md-normal">
                                <thead>
                                    <tr>
                                        <th className="align-middle">Username</th>
                                        <th className="align-middle d-none d-md-table-cell">Email</th>
                                        <th className="align-middle">Feedback</th>
                                        <th className="align-middle">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredFeedbacks.length > 0 ? (
                                        filteredFeedbacks.map(feedback => (
                                            <tr key={feedback._id}>
                                                <td className="align-middle">{feedback.username}</td>
                                                <td className="align-middle d-none d-md-table-cell">{feedback.email}</td>
                                                <td className="align-middle">{feedback.feedback}</td>
                                                <td className="align-middle">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        className="w-100"
                                                        onClick={() => handleDeleteButton(feedback)}
                                                    >
                                                        <i className="fas fa-trash-alt me-1"></i>
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No feedback found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        {/* Mobile: Card view */}
                        <div className="d-md-none">
                            {filteredFeedbacks.length > 0 ? (
                                filteredFeedbacks.map(feedback => (
                                    <div key={feedback._id} className="card mb-3 shadow-sm">
                                        <div className="card-body">
                                            <h2 className="card-title mb-2 h5">{feedback.username}</h2>
                                            <p className="card-text text-muted small mb-3">{feedback.email}</p>
                                            
                                            <div className="mb-3 pb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                                <div className="fw-bold mb-2">Feedback:</div>
                                                <p className="mb-0">{feedback.feedback}</p>
                                            </div>
                                            
                                            <div className="d-grid">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleDeleteButton(feedback)}
                                                >
                                                    <i className="fas fa-trash-alt me-2"></i>
                                                    Delete Feedback
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center p-4 text-muted">
                                    No feedback found
                                </div>
                            )}
                        </div>
                    </div>

                    
                </Col>
            </Row>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete feedback from <strong>{feedbackToDelete?.username}</strong>?
                </Modal.Body>
                <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <Button className="btn-cancel modal-action-btn" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" className="modal-action-btn" onClick={confirmDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default FeedbackControlPanel;

